@if (code()) {
  <span class="code-wrapper text-b3-s-500">
    {{ code() }}
    <button
      #tooltip="ngbTooltip"
      class="code-copy"
      triggers="manual"
      placement="right"
      (click)="onCopyCode()"
      (mouseenter)="tooltip.close()"
      [ngbTooltip]="tooltipContent"
      [autoClose]="false"
      [openDelay]="0"
      [closeDelay]="0"
    >
      <sd-icon [type]="iconTypes.COPY_LINK"></sd-icon>
    </button>
  </span>
}

<ng-template #tooltipContent>
  <div class="tooltip-content text-c2-s-300">{{ tooltipState().text }}</div>
</ng-template>
